"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isManualDatasourceConfigRequest = exports.isManualDatasourceConfig = void 0;
const isManualDatasourceConfig = (cfg) => {
    return cfg !== null && (Object.keys(cfg)?.length === 0 || 'clean_clones' in cfg);
};
exports.isManualDatasourceConfig = isManualDatasourceConfig;
const isManualDatasourceConfigRequest = (cfg) => {
    return cfg !== null && (Object.keys(cfg)?.length === 0 || 'clean_clones' in cfg);
};
exports.isManualDatasourceConfigRequest = isManualDatasourceConfigRequest;
